import {Component, OnInit, ElementRef, Output, EventEmitter, Input} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/_core/auth.service';
import { EntityService } from 'src/app/_core/entity.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import { OrderService } from 'src/app/_services/order.service';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    standalone: false
})
export class SidenavComponent implements OnInit {
	@Input() workMode: string;
	@Output() onSidenavClose: any = new EventEmitter();
	@Output() onSideNvaAction = new EventEmitter<any>();
	@Input() sideNav!: MatSidenav;

  constructor(
	  public appService: AppService,
	  public authService: AuthService,
	  public dialogsService: DialogsService,
	  public entityService: EntityService,
	  public orderService: OrderService,
	  elementRef: ElementRef
  ) {

  }

	passOrder() {
		this.dialogsService.passOrder();
	}

	reloadApp() {
		//this.authService.setHttpHeadersAccessToken('xxx', false, true);
		window.document.location.reload();
	}

	onAction(ev: any): void {
	  this.onSideNvaAction.emit(ev);
	  this.closeSidenav();
	}

	closeSidenav() {
		this.sideNav.close().then();
	}

	reload(){
		document.location.reload();
	}

  ngOnInit() {
  }

}

